/**
 * Variant Selector
 *
 * Listens for clicks on size/variant option buttons inside any
 * [data-variant-selector] container, and:
 *   1. Updates the hidden [data-selected-variant-id] input so the
 *      add-to-cart form submits the variant the customer actually clicked,
 *      not whatever was selected by default on page load.
 *   2. Toggles the visual `is-selected` state and `aria-pressed` for
 *      accessibility.
 *   3. Updates the displayed price, if a [data-product-price] element
 *      exists on the page (optional — degrades gracefully if not found).
 *
 * This file fixes the bug where add-to-cart always submitted the first
 * available variant regardless of what the customer clicked, because
 * the size options were static divs with no click handling at all.
 */

function initVariantSelectors() {
  const selectors = document.querySelectorAll('[data-variant-selector]');

  selectors.forEach((selector) => {
    const form = selector.closest('form') || document.querySelector('[data-product-form]');
    if (!form) return;

    const hiddenInput = form.querySelector('[data-selected-variant-id]');
    if (!hiddenInput) return;

    const priceDisplay = document.querySelector('[data-product-price]');

    selector.addEventListener('click', (event) => {
      const option = event.target.closest('[data-variant-id]');
      if (!option || option.disabled) return;

      const variantId = option.dataset.variantId;
      const variantPrice = option.dataset.variantPrice;

      // Update the actual form value — this is the core fix.
      hiddenInput.value = variantId;

      // Update visual selected state on all options in this selector.
      selector.querySelectorAll('[data-variant-id]').forEach((el) => {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-pressed', 'true');

      // Update displayed price if the page has a price element. Falls
      // back to raw cents-to-dollars if Shopify.formatMoney isn't
      // available — better to show something correct than fail silently.
      if (priceDisplay && variantPrice) {
        if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
          priceDisplay.textContent = window.Shopify.formatMoney(
            variantPrice,
            window.theme && window.theme.moneyFormat
          );
        } else {
          priceDisplay.textContent = `$${(parseInt(variantPrice, 10) / 100).toFixed(2)}`;
        }
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initVariantSelectors);
